<template lang="pug">
  .c-highlights
    .c-highlights--loaded
      HotelTeaser(v-if='listFull' :hotelLists='hotelList' :dateFormat='dateFormat' :timeFormat='timeFormat')
</template>

<script>
import HotelTeaser from '@/components/HotelTeaser.vue'
import hotelSchema from './utils/schemas/hotel.js'
import axios from 'axios'

export default {
  name: 'Hotel',
  props: ['hotelData'],
  components: {
    HotelTeaser
  },
  data() {
    return {
      hotelList: [],
      listFull: false,
      dateFormat: this.getDateFormat(),
      timeFormat: this.getTimeFormat()
    }
  },
  created() {
    let vm = this
    let pageType = 'undefined'
    let pageId = 'undefined'
    if (window.dataLayer.length > 0) {
      // fill up data for proper attribution
      if (window.dataLayer[0].hasOwnProperty('pageType')) {
        pageType = window.dataLayer[0].pageType
      }
      if (window.dataLayer[0].hasOwnProperty('pagePath')) {
        // for black pearl pages
        pageId = window.dataLayer[0].pagePath
      }
      if (window.dataLayer[0].hasOwnProperty('pagePostId')) {
        pageId = window.dataLayer[0].pagePostId
      }
    }
    if (window.gtm_tracking !== undefined && window.gtm_tracking !== null) {
      if (window.gtm_tracking.hasOwnProperty('pageType')) {
        pageType = window.gtm_tracking.pageType
      }
      if (window.gtm_tracking.hasOwnProperty('pagePath')) {
        // for black pearl pages
        pageId = window.gtm_tracking.pagePath
      }
      if (window.gtm_tracking.hasOwnProperty('pagePostId')) {
        pageId = window.gtm_tracking.pagePostId
      }
    }
    this.hotelData.product = pageType
    this.hotelData.pageid = pageId
    let searchData = hotelSchema.setHotelSchema(this.hotelData)
    axios
      .post('https://cna.holidaypirates.group/v1/search', searchData, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(function(response) {
        if (response.data.data.ranks[0].items.length > 0) {
          vm.hotelList.push(response.data)
          vm.listFull = true
        }
      })
  },
  methods: {
    getDateFormat() {
      if (this.$store.getters.getLocale === 'en-US') {
        return 'MM/DD/YYYY'
      }
      return 'DD.MM.YYYY'
    },
    getTimeFormat() {
      let timeFormat = 'HH:mm'
      return timeFormat
    }
  }
}
</script>
